
$(document).ready(function () {
   $(".home-banner-row").owlCarousel({
    loop: true,
    margin: 10,
     autoplay:true,
    nav: false,
    dots:true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });


   
     $('.cross-tooltip').each(function(index, item){
    $(item).on('click', function(){
        $(this).parents('.tooltip').fadeOut(500);
    });
});
   $('.cross-tooltip').click(function () {
        $('.works-banner-content .works-heading').css('padding-top', '0');
    });

});

function openNav() {
    document.getElementById("myNav").style.width = "100%";
    $("body").toggleClass("no-scroll");
}

function closeNav() {
    document.getElementById("myNav").style.width = "0%";
    $("body").toggleClass("no-scroll");
}


$(document).ready(function () {
    var owl = $('.all-slider').owlCarousel({
        items: 1,
        loop: true,
        nav: false,
        dots: false,
        autoplay: false,
        autoplayTimeout: 5000
    });


    $('.prev').click(function () {
        owl.trigger('prev.owl.carousel');
    });

    $('.next').click(function () {
        owl.trigger('next.owl.carousel');
    });
});


$(document).ready(function () {
    var owl = $('.Gains-all-slider').owlCarousel({
         items: 1,
    nav: true,
    // infinite: false,
    loop: true, // Enable loop
    speed: 300,
    dots: false,
    autoplay: false,
    });

    $('.btn-next').click(function () {
        owl.trigger('next.owl.carousel');
    });
    $('.btn-prev').click(function () {
        owl.trigger('prev.owl.carousel');
    });

    // owl.on('refreshed.owl.carousel changed.owl.carousel', function(event){
    //     var currentSlide = event.item.index;
    //     var totalSlides = event.item.count;
    //     var $slickPrev = $('.btn-prev');
    //     var $slickNext = $('.btn-next');

    //     if (currentSlide === 0) {
    //         $slickPrev.css('color', '#9b9999');
    //     } else {
    //         $slickPrev.css('color', '#000');
    //     }

    //     if (currentSlide === totalSlides - 1) {
    //         $slickNext.css('color', '#9b9999');
    //     } else {
    //         $slickNext.css('color', '#000');
    //     }
    // });
});







document.addEventListener("DOMContentLoaded", function () {
    var stepId = '#step-1';
    var stepContentId = '#step-1-content';
    $(stepId).css('opacity', '1');
    $(stepContentId).css('display', 'block');
    $('.key-step').click(function () {
        console.log("Key step clicked");
        var $this = $(this);
        if (!$this.hasClass('active-step')) {
            $('.key-step.active-step').removeClass('active-step');
            $('.steps-wrapper.active-step').slideUp(function () {
                $(this).removeClass('active-step');
                $this.addClass('active-step');
                $('#' + $this.attr('id') + '-content').slideDown().addClass('active-step');
            });
        }
    });
    var listItems = document.querySelectorAll('.steps-tabing ul li');
    listItems.forEach(function (item) {
        item.addEventListener('click', function () {
            listItems.forEach(function (li) {
                li.classList.remove('active');
                li.style.opacity = '0.2';
            });
            this.classList.add('active');
            this.style.opacity = '1';
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll('.faqs-tabing a');
    var first = tabs[0];
    $(first).css('color', 'white');
    $(first).css('background-color', 'black');
});

document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll('.faqs-tabing a');
    tabs.forEach(tab => {
        tab.addEventListener('click', function (event) {
            event.preventDefault();
            tabs.forEach(t => {
                t.classList.remove('faqs-a-active');
                t.style.color = 'black';
                t.style.backgroundColor = 'white';
            });
            this.classList.add('faqs-a-active');
            this.style.color = 'white';
            this.style.backgroundColor = 'black';
        });
    });
});

$(document).ready(function () {
    $('.faq-question').on('click', function () {
        var answer = $(this).siblings('.faq-answere');
        var openImage = $(this).children('.open');
        var closeImage = $(this).children('.close');
        openImage.toggleClass('hide-answ');
        closeImage.toggleClass('hide-answ');
        $('.faq-answere').not(answer).slideUp();
        answer.slideToggle();
        $('.faq-question').not($(this)).find('.open').removeClass('hide-answ');
        $('.faq-question').not($(this)).find('.close').addClass('hide-answ');
    });
});


$(document).ready(function () {
    $('.all').trigger('click');
    $('.faqs-tabing div').on('click', function () {
        var targetId = $(this).find('a').attr('href');
        $(targetId).removeClass('close-quest-answere').siblings().addClass('close-quest-answere');
    });
});

$('.review-slider-1').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1
});

$(document).ready(function () {
    $('.slider-home-content').slick({
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1
    });

    $(window).on('resize', function () {
        if ($(window).width() < 768) {

            $('.slider-home-content').slick('slickSetOption', 'slidesToShow', 2, true);
        } else if ($(window).width() === 768) {
                    $('.slider-home-content').slick('slickSetOption', 'slidesToShow', 3, true);
                }else {

            $('.slider-home-content').slick('slickSetOption', 'slidesToShow', 4, true);
        }
    }).resize();
});


$(document).ready(function () {
    $('.slider-concept-content').slick({
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1
    });

    $(window).on('resize', function () {
        var windowWidth = $(window).width();
        if (windowWidth < 768) {
            $('.slider-concept-content').slick('slickSetOption', 'slidesToShow', 1, true);
        } else if (windowWidth <= 1200) {
            $('.slider-concept-content').slick('slickSetOption', 'slidesToShow', 2, true);
        } else {
            $('.slider-concept-content').slick('slickSetOption', 'slidesToShow', 3, true);
        }
    }).resize();
});

$(document).ready(function () {
    var currentUrl = new URL(window.location.href);
    $('.bottom-header ul li a').removeClass('active-page');

    $('.bottom-header ul li a, .menu-links-support ul li a, .show-in-menu-2 ul li a').each(function () {
        var linkUrl = new URL($(this).prop('href'));
        console.log('Comparing:', linkUrl.href, currentUrl.href);
        if (linkUrl.href === currentUrl.href) {
            console.log('Match found! Adding class.');
            $(this).addClass('active-page');
        } else {
            console.log('Match not found');
        }
    });
});

$(document).ready(function () {
    var clickableElements = $(".package-item, .mailing-all-sec");

    clickableElements.css("cursor", "pointer");

    clickableElements.on("click", function () {
        window.location.href = "#";
    });
});


$(document).ready(function () {
    var clickableElements = $(".penile-all-content span ");

    clickableElements.css("cursor", "pointer");

    clickableElements.on("click", function () {
        window.location.href = "reviews.html";
    });
});
$(document).ready(function () {
    $(".btn-prev, .btn-next").hover(
        function () {
            $(this).find("img").css("opacity", "1");
        },
        function () {
            $(this).find("img").css("opacity", "");
        }
    );
});

$(document).ready(function(){
    var $responsiveSlider = $('.reviews-slider');
    
    $responsiveSlider.slick({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        draggable: false,
        arrows: false,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
        prevArrow: '<button type="button" class="slick-prev">&#8592;</button>',
        nextArrow: '<button type="button" class="slick-next">&#8594;</button>'

    });
    

    $responsiveSlider.on('afterChange', function(event, slick, currentSlide){
        var $slickPrev = $responsiveSlider.find('.slick-prev');
        var $slickNext = $responsiveSlider.find('.slick-next');

        if (currentSlide === 0) {
            $slickPrev.css('color', '#9b9999');
        } else {
            $slickPrev.css('color', '#000');
        }

        if (currentSlide === slick.slideCount - slick.options.slidesToShow) {
            $slickNext.css('color', '#9b9999');
        } else {
            $slickNext.css('color', '#000');
        }
    });
});


$(document).ready(function () {
    $('.another-slider').slick({
      dots: true,
      centerMode: true,
      centerPadding: '0',
      slidesToShow: 1,
      variableWidth: true,
      prevArrow: '<button type="button" class="another-slick-prev"><i class="fas fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="another-slick-next"><i class="fas fa-chevron-right"></i></button>'
    });
});






$(document).ready(function () {
    // Make a request to the ipinfo.io API
    $.get("https://ipinfo.io", function (response) {
        // Extract and display the location information
        $("#location").text(response.country);
    }, "json");
});




$('.flag-single').hide();

setTimeout(function() { 

  var locationContent = $('#location').text();
  
  if (locationContent.includes('GB')) {
      $('.flag-single.England').show();
  } else if (locationContent.includes('AU')) {
      $('.flag-single.Australia').show();
  } else if (locationContent.includes('US')) {
      $('.flag-single.US').show();
  } else if (locationContent.includes('CA')) {
      $('.flag-single.Canada').show();
  } else {
      $('.flag-single.US').show();
  }

});



$('.button-wrapper .quick-add').click(function (event) {
    event.stopPropagation(); // Stop the event from propagating to other event listeners
});


  $(function() {
    var $document = $(document);
    var selector = '[data-rangeslider]';
    var $element = $(selector);

    // For ie8 support
    var textContent = ('textContent' in document) ? 'textContent' : 'innerText';

    // Example functionality to demonstrate a value feedback
    function valueOutput(element) {

      var value = element.value;
      var output = element.parentNode.getElementsByTagName('output')[0] || element.parentNode.parentNode.getElementsByTagName('output')[0];
      output[textContent] = value+' inches';
    }
    $document.on('input', 'input[type="range"], ' + selector, function(e) {
      valueOutput(e.target);
    });

    // Basic rangeslider initialization
    $element.rangeslider({
      // Deactivate the feature detection
      polyfill: false,
      // Callback function
      onInit: function() {
        valueOutput(this.$element[0]);
      },
      // Callback function
      onSlide: function(position, value) {
        console.log('onSlide');
        console.log('position: ' + position, 'value: ' + value);
      },
      // Callback function
      onSlideEnd: function(position, value) {
        console.log('onSlideEnd');
        console.log('position: ' + position, 'value: ' + value);
      }
    });
  });
  
  function claculateSize(title)
  {
    var penis_size = $('#penis-size').val();
    var val_size = '';
    var enhanced_size = Number(penis_size) + 3;
	
    if(penis_size > 0) {
      if ( penis_size >= 0 && penis_size <= 4 ) {
        val_size = "sm";
      } else if ( penis_size >= 4.2 && penis_size <= 8 ) {
        val_size = "md";
      } else if ( penis_size >= 8.2 && penis_size <= 10 ) {
        val_size = "lg";
      } else if ( penis_size >= 10.2 && penis_size <= 16 ) {
        val_size = "xl";
      } else {
        val_size = "sm";
      }
      
      $('#strong_size').html(penis_size + ' inches');
      $('#congo_text').html('Congratulations! With the '+ title +' you will gain 3 inches');
      $('#enhanced_size').html(enhanced_size + ' inches');
      
      $('#psc-box').show();
      
    } else {
      $('#psc-box').hide();
    }
  }




$(document).ready(function(){
  $('.field__input[type="tel"]').on('input', function(e) {
    var input = $(this).val();
    // Remove non-numeric characters
    var numericInput = input.replace(/\D/g,'');
    // Limit to 14 characters
    var limitedInput = numericInput.substring(0, 14);
    $(this).val(limitedInput);
  });
});





/* update js*/


var scrolled = false;

window.addEventListener("scroll", function () {
    
    if (window.scrollY > 0 && !scrolled) {
        scrolled = true; 

        
        document.getElementById("header").style.backgroundColor = "#000000";
        var links = document.querySelectorAll('.bottom-header ul li a');
        links.forEach(function(link) {
            link.style.color = "white";
        });
        
        var menuBox = document.querySelector("#header .top-header .menu-box");
        menuBox.style.borderColor = "#FFF";
        var menuLinks = menuBox.querySelectorAll('a');
        menuLinks.forEach(function(link) {
            link.style.color = "white";
        });
        var menuImg = menuBox.querySelector('img');
        menuImg.style.filter = "invert(100%)";

   
        var headerFlags = document.querySelectorAll(".header-flag a");
        headerFlags.forEach(function(flag) {
            flag.style.color = "white";
        });

     
         var headerLogo = document.querySelector('.header__heading-logo-wrapper img');
        headerLogo.style.filter = "invert(100%)";
    } else if (window.scrollY === 0 && scrolled) {
        scrolled = false; // Update scroll state

     
        document.getElementById("header").style.backgroundColor = "#F1F1F1";
        var links = document.querySelectorAll('.bottom-header ul li a');
        links.forEach(function(link) {
            link.style.color = "";
        });
        
        var menuBox = document.querySelector("#header .top-header .menu-box");
        menuBox.style.borderColor = "#000";
        var menuLinks = menuBox.querySelectorAll('a');
        menuLinks.forEach(function(link) {
            link.style.color = "";
        });
        var menuImg = menuBox.querySelector('img');
        menuImg.style.filter = "";

       
        var headerFlags = document.querySelectorAll(".header-flag a");
        headerFlags.forEach(function(flag) {
            flag.style.color = "";
        });


        
        var headerLogo = document.querySelector('.header__heading-logo-wrapper img');
        headerLogo.style.filter = "none"; 
      
    }
});




